import React, { FC, useMemo, memo } from 'react';
import _find from 'lodash/find';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label, StyledFormikSimpleCheckbox } from '../../../shared/styles';
import { FiltersCountNameEnum } from '../../shared/types';

type Props = FilterData;

const NewTalent: FC<Props> = ({ name, label }) => {
  const { isSearching } = useDrawerSearchFilterNameOrCategory();
  const { filtersCounts } = useDrawerFiltersCounts();

  const count = useMemo(() => {
    return _find(filtersCounts?.[FiltersCountNameEnum.isNew], { key: 'true' })?.docCount || 0;
  }, [filtersCounts]);

  return (
    <>
      {isSearching && <Label>{label}</Label>}
      <StyledFormikSimpleCheckbox name={name} label={label} count={count} />
    </>
  );
};

export default memo(NewTalent);
